module.exports = false;


//////////////////
// WEBPACK FOOTER
// /Users/bizqsoft/Documents/project/ibqs/ibqs-dip-2023-09-09/~/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = 38